
import { Component, Vue, Watch } from 'vue-facing-decorator'
import OrderList from './com/order-list.vue'
import AmountLogList from './com/amount-log-list.vue'
import ScoreLogList from './com/score-log-list.vue'
import AdjustAmount from './com/adjust-amount.vue'

@Component({
  components: {
    OrderList,
    AmountLogList,
    ScoreLogList,
  }
})
export default class extends Vue {

  postData: any = null;
  loading = false;
  /** order | amount | score */
  activeTab = "order";

  get userId() {
    return this.$route.query.id;
  }

  async adjustAmount() {
    try {
      await this.$dialog({
        title: "调整用户金额",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustAmount data={this.postData}></AdjustAmount>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.getData();
    this.refreshAmountLog();
  }

  /** 余额流水 tab 已经打开过才会存在（lazy），没打开过时首次进入本来就会拉最新数据 */
  refreshAmountLog() {
    let list: any = this.$refs.amountLogList;
    if (list && list.refresh) {
      list.refresh();
    }
  }

  getGender(v) {
    switch (v) {
      case 1:
        return '男'
      case 2:
        return '女'
    }
    return '未知'
  }

  /** 跳到邀请人的详情，用当前路由 path，避免和菜单里配的 path 写死两份 */
  gotoInviter() {
    this.$goto({
      path: this.$route.path,
      query: { id: this.postData.inviterInfo.id },
    });
  }

  @Watch("$route.query.id")
  idWatcher() {
    this.getData();
  }

  async getData() {
    if (!this.userId) return;
    this.loading = true;
    let { error, data, message } = await this.$post("/manager/user/view", {
      id: this.userId,
    });
    this.loading = false;
    if (error) return this.$error(message);
    this.postData = data;
  }

  created() {
    this.getData();
  }
}
